import { render, staticRenderFns } from "./BudgetRecord.pug?vue&type=template&id=bad40fb6&scoped=true&lang=pug&"
import script from "./BudgetRecord.js?vue&type=script&lang=js&"
export * from "./BudgetRecord.js?vue&type=script&lang=js&"
import style0 from "./BudgetRecord.scss?vue&type=style&index=0&id=bad40fb6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad40fb6",
  null
  
)

export default component.exports